// extracted by mini-css-extract-plugin
export default {"Logo":"Logo__XTL3B","mark":"mark__WQ-uz","text":"text__qb3Qp"};